import React,{Component} from 'react'
import { Route,Switch  } from 'react-router-dom'
import Home from 'croutes/home'
import About from 'croutes/about'
import CareerView from 'croutes/careers'
import CounterView from 'croutes/counter'
import EnquiryView from 'croutes/enquiry'
import PrivacyView from 'croutes/privacyPolicy'
import PrivacyView2 from 'croutes/privacyPolicy2'
import CookieView from 'croutes/cookiePolicy'
import TermsConditionsView from 'croutes/termsConditions'
import 'font-awesome-sass-loader'
import NavbarSpacer from 'components/navbar/NavbarSpacer'
import Navbar from 'components/navbar/Navbar'
import { connect } from 'react-redux'
import scrollIntoView from 'scroll-into-view' ;


class App  extends Component {

    componentDidUpdate(prevProps) {
        // console.log("this.props.location",this.props.location)
        if (this.props.location.pathname !== prevProps.location.pathname ) {
            // if(this.props.location.pathname!=="/") {
            //     window.scrollTo(0, 0)
                //console.log("this.props.location",this.props.location)
            // } else {
            //     if (this.props.location.pathname ==="/" && this.props.location.hash ===""){
                   // window.scrollTo(0, 0)
                    // var topElem =document.getElementById("top")
                    // scrollIntoView(topElem,{ time:700, align:{
                    //     top:0,
                    //     left: 0
                    // }})
                    window.scrollTo(0, 0)
            //     }
            // }
        }
        //console.log("document.getElementById('root').scrollTop",document.getElementById('root'),document.getElementById('root').scrollTop,window.pageYOffset)

    }
    render() {
        return  (
            <div>
                <Switch>
                    <Route path='/'   component={NavbarSpacer}  exact />
                    <Route path='/'  component={Navbar}  />
                </Switch>
                <main>
                    <Switch>
                        <Route exact path="/" component={Home} />
                        <Route exact path="/about" component={About} />
                        <Route exact path="/careers" component={CareerView} />
                        <Route exact path="/counter" component={CounterView} />
                        <Route exact path="/enquiry" component={EnquiryView} />
                        <Route exact path="/privacy" component={PrivacyView2} />
                        <Route exact path="/cookie" component={CookieView} />
                        <Route exact path="/terms" component={TermsConditionsView} />
                    </Switch>
                </main>
            </div>
        )
    }
}
const mapDispatchToProps = {
}

const mapStateToProps = (state, props) => ({
    location: state.router.location
})


export default connect(mapStateToProps, mapDispatchToProps )( App)




// WEBPACK FOOTER //
// ./src/layouts/app/index.js